import React from 'react';
import styled from 'styled-components';

import Checkbox from '../../../Checkbox';

interface ITicketNoOrderFilter {
  value?: string[];
  name: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const TicketNoOrderFilter = ({
  value,
  name,
  onChange,
}: ITicketNoOrderFilter) => {
  const isChecked = Array.isArray(value) && value.includes('none');

  return (
    <StyledFilter>
      <li key="no_order">
        <StyledCheckbox
          checked={isChecked}
          onChange={onChange}
          name={name}
          value="none"
        >
          <span>Без заказа</span>
        </StyledCheckbox>
      </li>
    </StyledFilter>
  );
};

const StyledFilter = styled.ul``;

const StyledCheckbox = styled(Checkbox)`
  span {
    margin-left: 4px;
  }
`;

export default TicketNoOrderFilter;
